// @flow

import React from 'react';
import Pill from 'shared/components/common/Pill';
import { i18n } from 'shared/utils';

type Props = {
  status: string,
  width?: number,
};

const STATUS_COLORS = {
  DRAFT: 'grey',
  SENT: 'blue',
  PARTIALLY_PAID: 'orange',
  PAID: 'green',
  OVERDUE: 'red',
  VOID: 'darkGrey',
};

const STATUS_LABELS = {
  DRAFT: 'Draft',
  SENT: 'Sent',
  PARTIALLY_PAID: 'Partially Paid',
  PAID: 'Paid',
  OVERDUE: 'Overdue',
  VOID: 'Void',
};

const InvoiceStatusPill = ({ status, width }: Props) => (
  <Pill color={STATUS_COLORS[status] || 'grey'} width={width}>
    {i18n.t(STATUS_LABELS[status] || status)}
  </Pill>
);

InvoiceStatusPill.defaultProps = {
  width: 110,
};

export default InvoiceStatusPill;
